export default "__VITE_ASSET__bcf687c4__"